import React, { useCallback, useContext, useEffect, useState } from "react";
import Services from "../../network/Services";
import { formatNumberToUS } from "../../control/Constant";
import { DatePicker } from "antd";
import { UserContext } from "../../App";


const Finance = ({selectDate,setSelectDate,customDate,setCustomdate}) => {
    const [dataItems,setDataitems] = useState([{name:'Total Revenue',total:0},{name:'Total AMA',total:0},{name:'Total Fee Agreement',total:0}])
    const [selectedOptions,setSelectedoptions] = useState('totalRevenue')
    // const [selectDate,setSelectDate] = useState(0)
    // const [customDate,setCustomdate] = useState({startDate:'',endDate:''})
    const { setLoader } = useContext(UserContext)

    useEffect(()=>{
        if(selectDate == 'custom') return;
        getFinancecalculationfunc(2)
    },[selectDate])

    const getFinancecalculationfunc = () => {
        let today = selectDate == 'custom' ? new Date(customDate.startDate) : new Date()
        let endDate = selectDate == 'custom' ? new Date(customDate.endDate) :  new Date(today);
        if(selectDate != 'custom'){
        endDate.setDate(endDate.getDate() - selectDate);
        }

        let json = {
        "subtenantId": 2,
        "startDate":selectDate > 0 ? endDate : selectDate == 'custom' ? new Date(customDate.startDate) : '',
        "endDate": selectDate > 0 ? today : selectDate == 'custom' ? new Date(customDate.endDate) : ''
        }
        // console.log(json,'kflsssssssssss')
        setLoader(true)
        const getFinancecalculation = Services.getFinancecalculation(json)
        getFinancecalculation.then((res)=>{
        setLoader(false)
        // console.log(res.data.data,"responsegetFinancecalculation")
        let response = res.data.data

        setDataitems([
            {name:'Total Revenue',totalRevenue:response.totalRevenue,totalRevenueByCard: response.totalRevenueByCard,totalRevenueByCash: response.totalRevenueByCash,totalRevenueByCheque: response.totalRevenueByCheque},
            {name:'Total AMA',total:response.totalAMA},
            {name:'Total Fee Agreement',total:response.totalFeeAgreement}
        ])
    }).catch((err)=>{
        setLoader(false)
            console.log(err,'error')
        })
    }

    const customFunc = ()=>{
        getFinancecalculationfunc(2)
    }


    // console.log(selectedOptions,"selectedOptions",dataItems[0][selectedOptions])
     return (
        <div className="d-flex align-items-center justify-content-between m-2 border-bottom w-100 p-0">
            {dataItems.map((e)=>(
                <div className="cardItem m-2 mb-3" style={{width:'350px'}}>
                <div className="d-flex align-items-center justify-content-between gap-3">
                <p className="mt-2 text-start">{e.name}</p>
                {e.name == 'Total Revenue' && <select className="paralegaldata-select cursor-pointer" onChange={(e)=>setSelectedoptions(e.target.value)}><option value='totalRevenue'>All</option><option value='totalRevenueByCard'>Card</option><option value='totalRevenueByCash'>Cash</option><option value='totalRevenueByCheque'>Cheque</option></select>}
                </div>
                <p className="text-start fs-5">{e.name == 'Total Revenue' ? formatNumberToUS(e[selectedOptions]) :e.total}</p>
                </div>
            ))}
            <div className="me-3">
                <div className="fw-bold">Filter By Date: {selectDate != 'custom' ? '' : ''}<select className="mt-3 p-1" onChange={(e)=>setSelectDate(e.target.value)}><option value="null">Till Now</option><option value='1'>Today</option><option value='7'>This week</option><option value='30'>This month</option><option value='90'>Last three months</option><option value='180'>Last six months</option><option value="custom">Custom</option></select></div>
                {selectDate == 'custom' && <div className="my-1 text-start w-100"><div className="d-flex gap-1"><DatePicker placeholder="Start Date" format='MM/DD/YYYY' value={customDate.startDate} onChange={(e)=>{setCustomdate(prev=>{return{...prev,startDate:e}})}}/><DatePicker placeholder="End Date" format='MM/DD/YYYY' value={customDate.endDate}  onChange={(e)=>{setCustomdate(prev=>{return{...prev,endDate:e}})}} /></div><button className="primary-btn ms-2 mt-2" onClick={()=>customFunc()}>Apply</button></div>}
            </div>
        </div>
     )
}
export default Finance;